// extracted by mini-css-extract-plugin
module.exports = {"logo":"_23G0l8x"};